import { queryOptions as baseQueryOptions } from "@tanstack/react-query";

import type { Promisable } from "@core/foundation/promise";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function queryOptions<
  Args extends readonly [] | readonly [unknown],
  Response,
>({
  queryFn,
  queryKey: { group, variant = () => [] },
  refetchInterval,
}: {
  readonly queryFn: (...args: Args) => Promisable<Response>;
  readonly queryKey: {
    readonly group: (...args: Args) => readonly unknown[];
    readonly variant?: (...args: Args) => readonly unknown[];
  };
  readonly refetchInterval?: number;
}) {
  // oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
  const factory = (...args: Args) => {
    const groupQueryKey = group(...args);

    const fullQueryOptions = baseQueryOptions({
      queryFn: async () => queryFn(...args),
      queryKey: [...groupQueryKey, ...variant(...args)],
      refetchInterval,
    });

    return Object.assign(fullQueryOptions, { groupQueryKey });
  };

  return factory;
}
